import { VacancyEducationLevelModel } from './VacancySkill';

export interface VacancyEducationInfoModel {
  vacancy_id: string | null;
  education_levels: VacancyEducationLevelModel[] | null;
}
